import React, { useCallback, useState } from "react";
import {
  RowDetailState,
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
} from "@devexpress/dx-react-grid";
import {
  Grid as DataGrid,
  Table,
  TableHeaderRow,
  TableRowDetail,
  PagingPanel,
  SearchPanel,
  Toolbar,
} from "@devexpress/dx-react-grid-material-ui";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import PropTypes from "prop-types";
import { withStyles, Grid, Paper, CircularProgress } from "@material-ui/core";
import { GET_MY_DEALERS_SALE, PENDING_BOAT_REQUEST } from "../queries";
import { useQuery, useSubscription } from "@apollo/client";
import auth from "Auth";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: "none",
  },
  root: {
    padding: theme.spacing(),
  },
  item: {
    height: "100%",
  },
  marginFix: {
    marginTop: 19,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
  },
  gridContainer: {
    display: "flex",
    flexDirection: "column",
  },
  tableFilter: {
    display: "flex",
  },
});

const RowDetail = ({ row }) => (
  <div>
    <table cellSpacing="0" className="detailTable">
      <tbody>
        <tr>
          <td>Visible On:</td>
          <td>{row?.site}</td>
        </tr>
        <tr>
          <td>Submitted By:</td>
          <td>{row?.dealer}</td>
        </tr>
        <tr>
          <td>Status:</td>
          <td>{row?.status}</td>
        </tr>
        <tr>
          <td>Name:</td>
          <td>{row?.name}</td>
        </tr>
        <tr>
          <td>Address:</td>
          <td>
            {row?.address}&nbsp;{row?.address2}
            <br />
            {row?.city}&nbsp;{row?.region}, {row?.country} {row?.zipcode}
            <br />
          </td>
        </tr>
        <tr>
          <td>Brands:</td>
          <td>{row?.brands}</td>
        </tr>
        <tr>
          <td>Description:</td>
          <td>{row?.description}</td>
        </tr>
        <tr>
          <td>Start Date:</td>
          <td>{row?.start_date}</td>
        </tr>
        <tr>
          <td>End Date:</td>
          <td>{row?.end_date}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

function SalesPendingBoatShow(props) {
  const { classes } = props;
  const [columns] = useState([
    { name: "created_at", title: "Date Submitted" },
    { name: "dealer", title: "Dealer" },
    { name: "name", title: "Boat Show Name" },
    { name: "city", title: "Location" },
    { name: "status", title: "Status" },
  ]);

  const [dateColumns] = useState(["created_at"]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedField, setSelectedField] = useState("Date Submitted");
  const [queryData, setQueryData] = useState();

  const { data: salesData, loading } = useQuery(GET_MY_DEALERS_SALE, {
    notifyOnNetworkStatusChange: true,
    variables: { profile_id: auth.getSub() },
    fetchPolicy: "cache-and-network",
  });

  const { data: boatData, loading: boatLoading } = useSubscription(
    PENDING_BOAT_REQUEST,
    {
      notifyOnNetworkStatusChange: true,
      skip: salesData === undefined,
      variables: {
        profileIds: [
          ...(salesData?.sales_assign?.map((e) => e?.assign_user_id) || []),
          auth.getSub(),
        ],
      },
      fetchPolicy: "cache-and-network",
    }
  );

  const changeSearchValue = (newValue) => {
    setSearchValue(newValue);
  };

  const FieldDropdown = ({ fields, selectedField, onSelectField }) => (
    <select
      value={selectedField}
      onChange={(e) => onSelectField(e.target.value)}
    >
      {fields?.map((field) => (
        <option key={field} value={field}>
          {field}
        </option>
      ))}
    </select>
  );

  const handleFieldChange = (selectedField) => {
    setSelectedField(selectedField);
    setSearchValue("");
  };

  const filteredRows = boatData?.boat_shows?.filter((row) => {
    let name =
      row?.[
        columns?.find((e) => e?.title === selectedField)?.name
      ]?.toLowerCase();

    const searchText = searchValue?.toLowerCase().trim();
    return name?.includes(searchText);
  });

  return (
    <Paper className={classes.paper} style={{ margin: "2em 0px" }}>
      <Grid container>
        <Grid item xs align="center">
          {loading || boatLoading ? (
            <CircularProgress />
          ) : (
            <div className={classes.gridContainer}>
              <DataGrid rows={filteredRows || []} columns={columns}>
                <SearchState
                  value={searchValue}
                  onValueChange={changeSearchValue}
                />
                <PagingState defaultCurrentPage={0} pageSize={10} />
                <IntegratedFiltering />
                <IntegratedPaging />
                <RowDetailState defaultExpandedRowIds={[0]} />
                <Table />
                <TableHeaderRow />
                <PagingPanel />
                <TableRowDetail contentComponent={RowDetail} />
                <Toolbar />
                <div
                  className={`${
                    selectedField === "Brand"
                      ? "tableFilter selectbrand"
                      : "tableFilter"
                  }`}
                >
                  <div className="wrapper">
                    <FieldDropdown
                      fields={columns?.map((column) => column?.title)}
                      selectedField={selectedField}
                      onSelectField={handleFieldChange}
                    />
                    <SearchPanel />
                  </div>
                </div>
              </DataGrid>
            </div>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}

SalesPendingBoatShow.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withRouter, withStyles(styles))(SalesPendingBoatShow);

{
  /* <select value={filterBy} onChange={e => setFilterBy(e.target.value)}>
                        <option value="name">Dealer Name</option>
                        <option value="boat_show">Boat Show Name</option>
                        <option value="location">Location</option>
                        <option value="date">Date Submitted</option>
                    </select> */
}
{
  /* <input
                        type="search"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            handleOnChange(e.target.value);
                        }}
                    /> */
}

// const handleOnChange = useCallback(
//     debounce((value) => {
//         setSearch(value)
//     }, 1000),
//     []
// );

// const getQueryVariables = () => {
//     let where = { status: { _eq: "Pending" } };
//     const formattedSearchTerm = `%${search}%`;

//     if (filterBy === 'name') {
//         where._or = [{ dealer: { _ilike: "%" + formattedSearchTerm + "%" } }]
//     } else if (filterBy === 'boat_show') {
//         where._or = [{ name: { _ilike: "%" + formattedSearchTerm + "%" } }]
//     } else if (filterBy === 'location') {
//         where._or = [{ city: { _ilike: "%" + formattedSearchTerm + "%" } }]
//     } else if (filterBy === 'date') {
//         const parsedDate = moment(search, 'MM/DD/YYYY', true);

//         if (parsedDate.isValid()) {
//             const comparisonValue = parsedDate.format('YYYY-MM-DD');
//             where._or = [{ created_at: { _eq: comparisonValue } }];
//         }
//     }
//     return { where };
// }

// const { loading, data, error } = useSubscription(PENDING_BOAT_REQUEST, {
//     notifyOnNetworkStatusChange: true,
//     fetchPolicy: "cache-and-network",
// });
